/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AutocompleteTerm = {
    type?: AutocompleteTerm.type;
    id?: string;
    name?: string;
    caption?: string;
};
export namespace AutocompleteTerm {
    export enum type {
        COUNTRY = 'country',
        VOIVODESHIP = 'voivodeship',
        REGION = 'region',
        CITY = 'city',
        ACCOMMODATION = 'accommodation',
        POI = 'poi',
    }
}
